UC.views.AccountVerifyBankAccount = Backbone.View.extend({

  events: {
    'click #btnVerifyAccount' : 'submit'
  },

  initialize: function() {
    this.btnLoader = this.$el.find('#btnVerifyAccount').buttonLoader();
    this.isDescriptorCode = UC.constants.microdepositType === 'descriptor_code';
    this.$amount1 = this.$el.find('#txtAmount1');
    this.$amount2 = this.$el.find('#txtAmount2');
    this.$descriptorCode = this.$el.find('#txtDescriptorCode');
  },

  submit: function(e) {
    if (this.validate()) {
      this.btnLoader.showLoader();
      var data = {
        account: {
          id: UC.constants.accountId
        }
      };

      if (this.isDescriptorCode) {
        data.account.descriptor_code = this.descriptorCode;
      } else {
        data.account.amount1 = this.amount1;
        data.account.amount2 = this.amount2;
      }

      UC.net.post('/account/confirm_bank_account', data).fail(function(){
        this.btnLoader.hideLoader();
      }.bind(this));
    }
  },

  validate: function() {
    var errors = [];
    UC.utils.clearValidationErrors();

    if (this.isDescriptorCode) {
      this.descriptorCode = this.$descriptorCode.val().trim();
      if (!this.descriptorCode) {
        errors.push({element: this.$descriptorCode, text: 'Please enter the descriptor code from your bank statement'});
      }
    } else {
      this.amount1 = parseInt(this.$amount1.val());
      this.amount2 = parseInt(this.$amount2.val());
      if (isNaN(this.amount1) || this.amount1 <= 0 || this.amount1 >= 100 || isNaN(this.amount2) || this.amount2 <= 0 || this.amount2 >= 100) {
        errors.push({element: this.$amount1, text: 'Please enter amount between 1 and 99'});
      }
    }

    UC.utils.showValidationErrors(errors);
    return errors.length === 0;
  }

});
